module.exports = __webpack_public_path__ + "img/handraw_paiement bleu.9bf7e920.svg";